import DeleteIcon from '@atlaskit/icon/core/delete';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { analyticsClient } from '@databases/analytics';
import { messages } from '@databases/intl/messages';
import React from 'react';

import { deleteFields } from '../actions/delete-fields';
import { type MenuItemBuilder, SELECT_VALUE_MENU_ACTIONS } from '../types';
import { ElementBeforeIconWrapper } from '../ui/components';

export const deleteFieldsMenuItem: MenuItemBuilder = ({
  capabilities: { canDeleteFields },
  contentId,
  dialogs: { showDialog },
  fieldId,
  formatMessage,
  isHoverDeleteFieldsButton,
  panelManager,
  selectionsActions,
  selectedFieldIds,
  selectedFieldsCount,
}) => {
  const { fieldId: panelFieldId } = panelManager.getData('FieldSettingsPanel') || {};

  return {
    isEnabled: () => canDeleteFields,
    menuItem: {
      key: SELECT_VALUE_MENU_ACTIONS.DELETE_FIELDS,
      content: formatMessage(messages['field-actions.delete'], {
        fieldCount: selectedFieldsCount.toString(),
      }),
      onClick: () =>
        deleteFields({
          contentId,
          formatMessage,
          client: analyticsClient,
          fieldId: fieldId,
          hidePanel: panelManager.hidePanel,
          showDialog,
          panelFieldId,
          selectionsActions,
        }),
      closeOnClick: true,
      onMouseEnter: () => {
        selectionsActions.setSelectionIntent({ type: 'delete', target: 'fields' });
        selectionsActions.selectFields(selectedFieldIds, {
          clearSelectedValues: false,
        });
      },
      onMouseLeave: () => {
        selectionsActions.clearSelectionIntent();
        selectionsActions.selectFields([], { clearSelectedValues: false });
      },
      elemBefore: (
        <ElementBeforeIconWrapper>
          <DeleteIcon
            label=""
            spacing="spacious"
            color={
              isHoverDeleteFieldsButton
                ? token('color.icon.danger', colors.R500)
                : undefined
            }
          />
        </ElementBeforeIconWrapper>
      ),
    },
  };
};
